<script setup lang="ts">
import type { AdditionalToastServiceMethods } from "@/components/toast/toast-context.ts";
import type { ToastMessageOptions } from "primevue/toast";

import { computed } from "vue";

import { ToastContext } from "@/components/toast/toast-context.ts";

import { useToast } from "primevue/usetoast";

const toast = useToast();

const $toast = computed<AdditionalToastServiceMethods>(() => {
  return {
    add(message: ToastMessageOptions) {
      toast.add({
        life: 1000 * 10,
        closable: true,
        severity: "info",
        ...message,
      });
    },
    remove(message: ToastMessageOptions) {
      toast.remove({
        life: 1000 * 10,
        closable: true,
        severity: "info",
        ...message,
      });
    },
    removeGroup(group: string) {
      toast.removeGroup(group);
    },
    removeAllGroups() {
      toast.removeAllGroups();
    },
    success(msg: unknown, opts?: ToastMessageOptions) {
      toast.add({
        life: 1000 * 10,
        closable: true,
        severity: "success",
        detail: msg,
        ...opts,
      });
    },
    info(msg: unknown, opts?: ToastMessageOptions) {
      toast.add({
        life: 1000 * 10,
        closable: true,
        severity: "info",
        detail: msg,
        ...opts,
      });
    },
    warn(msg: unknown, opts?: ToastMessageOptions) {
      toast.add({
        life: 1000 * 10,
        closable: true,
        severity: "warn",
        detail: msg,
        ...opts,
      });
    },
    error(msg: unknown, opts?: ToastMessageOptions) {
      toast.add({
        life: 1000 * 10,
        closable: true,
        severity: "error",
        detail: msg,
        ...opts,
      });
    },
  } satisfies AdditionalToastServiceMethods;
});
</script>

<template>
  <ToastContext.Provider
    :value="{
      add: $toast.add,
      remove: $toast.remove,
      removeAllGroups: $toast.removeAllGroups,
      removeGroup: $toast.removeGroup,
      success: $toast.success,
      info: $toast.info,
      warn: $toast.warn,
      error: $toast.error,
    }"
  >
    <slot></slot>
  </ToastContext.Provider>
</template>

<style scoped></style>
